var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"k-radio-button-group",attrs:{"role":"radiogroup","aria-readonly":_vm.readonly}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }